import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Divider,
  TextField,
  Button,
  useMediaQuery,
} from "@mui/material";
import HomeCarousel from "../home-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import FranchiseBackground from "./images/franchise-background.png";
import stroke from "./images/paint-stroke.png";
import Gallery from "./carousel";
import "./styles.scss";
import FranchiseDataForm from "../franchise/franchise-data-form";
import { Link, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"; 
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  homeBG,
  mobileHomeBG,
  zone1,
  zone2,
  zone3,
  zone4,
  zone5,
  zone6,
  zone7,
  zone8,
} from "../../assets";

function Home({}) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [showAllZones, setShowAllZones] = useState(false);

  const handleZoneClick = (zoneTitle) => {
    navigate(`/zone/${zoneTitle.toLowerCase().replace(" ", "-")}`);
  };

  const zones = [
    { img: zone1, title: "Zone 1", id: "zone1" },
    { img: zone2, title: "Zone 2", id: "zone2" },
    { img: zone3, title: "Zone 3", id: "zone3" },
    { img: zone4, title: "Zone 4", id: "zone4" },
    { img: zone5, title: "Zone 5", id: "zone5" },
    { img: zone6, title: "Zone 6", id: "zone6" },
    { img: zone7, title: "Zone 7", id: "zone7" },
    { img: zone8, title: "Zone 8", id: "zone8" },
  ];

  const displayedZones = showAllZones ? zones : zones.slice(0, 4);

  return (
    <Grid className="home">
      <HomeCarousel />
    </Grid>
  );
}

export default Home;
